import React, { Component } from "react";
import { connect } from "react-redux";
import Draggable from "react-draggable";
import WaitlistForm from "./Form";
import { getStaffServicesAndMore } from "../../../actions/waitlist";
import GlobalError from "../../shared/globalError";
import GlobalSuccess from "../../shared/globalSuccess";
import { Loading } from "genbook-components";

class WaitlistModal extends Component {
  componentDidMount() {
    const { dispatchGetStaffServicesAndMore } = this.props;

    if (window.self === window.top) {
      dispatchGetStaffServicesAndMore();
    }

    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (iOS) {
      document.body.style.cursor = "pointer"; //DES-777 to make click event to fire in ios.
    }
  }

  handleCloseModal = () => {
    let event = new CustomEvent("messageFromUsToParent", {
      detail: { action: "close" },
    });
    window.dispatchEvent(event);
  };

  render() {
    const { submitError, submitSuccess } = this.props;
    return (
      <div className="gb-waitlist-modal">
        <Draggable handle=".drag-handler">
          <div className="gb-waitlist-content">
            <div className="drag-handler">
              <GlobalError customMessage={submitError} />
              <GlobalSuccess
                customMessage={submitSuccess && "Customer added to waitlist"}
              />
              <div className="waitlist-modal-title">
                <span>Add customer to Waitlist</span>
                <button
                  key="close"
                  type="button"
                  onClick={this.handleCloseModal}
                  className="close_button2"
                />
              </div>
            </div>
            <WaitlistForm closeModal={this.handleCloseModal} />
          </div>
        </Draggable>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  submitError: state.waitlistStepReducer.waitlistStepData.submitError,
  submitSuccess: state.waitlistStepReducer.waitlistStepData.submitSuccess,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchGetStaffServicesAndMore: () => dispatch(getStaffServicesAndMore()),
});

WaitlistModal = connect(mapStateToProps, mapDispatchToProps)(WaitlistModal);

export default WaitlistModal;
